<template>
    <div class="history-point m-auto" data-cy="container_history_getfriend_list_main">
        <div class="w-3/4 mx-auto" data-cy="container_history_getfriend_month_picker">
            <MonthPickerDropdown
                v-model:inputValue="monthSelect"
                :inputLbl="lbl.history.monthPicker"
                :isShowDate="false"
                data-cy="input_history_getfriend_month_picker"
                @update:inputValue="onMonthSelect()"
            ></MonthPickerDropdown>
        </div>
        <div class="px-4" v-show="historyList.length > 0 && isLoaded" data-cy="container_history_getfriend_list">
            <!-- <HistoryGetFriendItem
                    v-for="(v) in historyList"
                    :key="v.rowKey"
                    :pointItem="v"
            ></HistoryGetFriendItem> -->

            <!-- just show sum data -->
            <div class="bg-white shadow-custom px-4 py-4.5 my-4 rounded-lg border border-a-gray-d9d9d9" data-cy="card_history_getfriend_summary">
                <div class="flex justify-between text-14">
                    <div class="w-3/5">
                        <div class="text-a-gray-666666" data-cy="text_history_getfriend_item_msg">
                            {{ lbl.getfriend.item_msg }}
                        </div> 
                    </div>
                    <div class="w-2/5 font-bold text-a-blue-2140a6 text-right" data-cy="text_history_getfriend_item_count">
                        {{ `${itemCount} ${unitCount}` }}
                    </div>
                </div>
            </div>
        </div>
        <div v-show="historyList.length == 0 && isLoaded" data-cy="container_history_getfriend_no_data">
            <Nodata
                :textData="lbl.getfriend.no_data"
                :isTextOnly="true"
                data-cy="text_history_getfriend_no_data" />
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';
//component
import MonthPickerDropdown from '@/components/Input/label/MonthPickerDropdown.vue';
// import HistoryGetFriendItem from './HistoryGetFriendItem.vue'
import Nodata from '@/components/Layout/Page/NoData.vue';
//service
import BzbsGetFriend from '@/core/GetFriend/service/BzbsGetFriend';
import { GetFriendConfigBuilder } from '@/core/GetFriend/config/GetFriendConfigModel.js'

export default {
    name: 'HistoryPoint',
    mixins: [LocaleMixin, ModalMixin],
    components: {
        MonthPickerDropdown,
        // HistoryGetFriendItem,
        Nodata,
    },
    data: function() {
        return {
            monthSelect: new Date(),
            historyList: [],
            itemCount: 0,
            isLoaded: false,
            unitCount: '',
        };
    },
    methods: {
        onMonthSelect: async function() {
            Util.log('select month', this.monthSelect);

            let configParams = new GetFriendConfigBuilder()
                    .setMonth(this.monthSelect)
                    .setTop(100)
                    .create()
                    .getParams();
            
            this.modal.loadingModal.show();
            await this.getHistoryGetFriend(configParams);
            this.modal.loadingModal.hide();
        },
        getHistoryGetFriend: function(configParams) { 
            return new Promise((resolve) => {
                BzbsGetFriend.apiGetFriendHistory(configParams).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.historyList = data;
                        this.itemCount = data.length;
                        this.unitCount = this.getUnitTxt();
                        this.isLoaded = true;
                        resolve(data);
                    },
                    error: (err) => {
                        if(err.id == 401){
                            this.$router.push('/error');
                        }else{
                            this.errorApi(err);
                        }
                        resolve(null);
                    },
                })
            });
            
        },
        getUnitTxt: function () { 
            var unitText = this.localeCode === 1033 && this.itemCount > 1
                        ? this.lbl.getfriend.unit_count + 's'
                        : this.lbl.getfriend.unit_count;

            return unitText;
        },
    },
}
</script>
<style lang="scss" scoped>
    .history-point {
        max-width: 500px;
    }
</style>
